import React from "react";

const PostHeader = ({
  image,
  postProviderGroup,
  postProvider,
  time,
  privacyIcon,
}) => {
  return (
    <div className="flex justify-start items-center">
      <img
        className="h-10 w-10 mr-2 object-contain rounded-lg cursor-pointer"
        src={image}
      />
      <div>
        <span className=" font-semibold text-gray-200">
          {postProviderGroup}
        </span>
        <div className="flex justify-start items-center text-gray-400 text-xs">
          <span className="mr-1"> {postProvider}</span>{" "}
          <span className="mr-1">.</span>
          <span className="mr-1">{time}</span>
          <span className="mr-1">.</span>
          <span className="mr-1">{privacyIcon}</span>
        </div>
      </div>
    </div>
  );
};

export default PostHeader;
